<div [formGroup]="this.kitItemSelectStruct.formGroup">
  <div class="row">
    <div class="col-4 col-sm-4 col-md-4">
      <app-select-2 [formControlField]="'idItem'" [preSelectedlist]="kitItemSelectStruct.preSelectedItem" (selectedValue)="setItemId($event)"
        [multiple]="false" [url]="urlListAllItem" [idField]="'idItem'" [nameField]="'codeWithName'"
      [labelField]="'Material'"></app-select-2>
    </div>
    <div class="col-4 col-sm-4 col-md-3">
      <mat-form-field appearance="outline">
        <mat-label>Quantidade</mat-label>
        <input matInput type="number" formControlName="amount"  min="0" oninput="validity.valid||(value=null);">
        @if (kitItemSelectStruct.formGroup.get('amount').invalid) {
          <mat-error>Informe a quantidade</mat-error>
        }
        <span matSuffix>{{amount}}</span>
      </mat-form-field>
    </div>
    <div class="col-4 col-sm-4 col-md-3">
      <button class="panel-origin-button " color="primary" mat-mini-fab type="button" (click)="add()">
        <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
      </button>
      @if (!this.kitItemSelectStruct.isSingle) {
        <button class="panel-origin-button " color="primary" mat-mini-fab type="button" (click)="remove()"
          >
          <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
        </button>
      }
    </div>
  </div>
</div>